<template>
  <div class="ocr-mapping-stepper">
    <div class="ocr-mapping-stepper-rail" role="tablist" aria-label="Mapping steps">
      <button
        v-for="(step, index) in steps"
        :key="step.id"
        type="button"
        class="ocr-mapping-stepper-step"
        :class="{
          'ocr-mapping-stepper-step--active': index === modelValue,
          'ocr-mapping-stepper-step--done': index < modelValue,
        }"
        @click="$emit('update:modelValue', index)"
      >
        <span class="ocr-mapping-stepper-step-num">{{ index + 1 }}</span>
        <span class="ocr-mapping-stepper-step-label">{{ step.label }}</span>
      </button>
    </div>
    <div class="ocr-mapping-stepper-nav">
      <v-btn size="small" variant="outlined" :disabled="modelValue <= 0" @click="$emit('update:modelValue', modelValue - 1)">
        &lt; {{ prevLabel }}
      </v-btn>
      <v-btn
        v-if="modelValue < steps.length - 1"
        size="small"
        variant="outlined"
        :disabled="modelValue >= steps.length - 1"
        @click="$emit('update:modelValue', modelValue + 1)"
      >
        {{ nextLabel }} &gt;
      </v-btn>
      <v-btn
        v-else-if="modelValue === steps.length - 2"
        size="small"
        color="primary"
        variant="flat"
        :loading="saving"
        @click="$emit('save-finish')"
      >
        Save &amp; finish
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "OcrMappingStepper",
  props: {
    modelValue: { type: Number, default: 0 },
    steps: {
      type: Array,
      default: () => [
        { id: "edit", label: "Edit" },
        { id: "columns", label: "Map Columns" },
        { id: "header", label: "Map Header" },
        { id: "review", label: "Review" },
        { id: "saved", label: "Saved" },
      ],
    },
    saving: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "save-finish"],
  computed: {
    prevLabel() {
      if (this.modelValue <= 0) return "Edit";
      return this.steps[this.modelValue - 1]?.label || "Previous";
    },
    nextLabel() {
      if (this.modelValue >= this.steps.length - 1) return "";
      return this.steps[this.modelValue + 1]?.label || "Next";
    },
  },
};
</script>
